// Copyright © 2025 The Things Industries B.V.

import sharedMessages from '@ttn-lw/lib/shared-messages'
import Yup from '@ttn-lw/lib/yup'

const labelFormValidation = Yup.object().shape({
  name: Yup.string()
    .min(3, Yup.passValues(sharedMessages.validateTooShort))
    .max(50, Yup.passValues(sharedMessages.validateTooLong))
    .matches(/^[a-zA-Z0-9\s]*$/, Yup.passValues(sharedMessages.labelValidation))
    .required(sharedMessages.validateRequired),
  description: Yup.string().max(2000, Yup.passValues(sharedMessages.validateTooLong)),
  color: Yup.string()
    .matches(
      /^(#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|))$/,
      Yup.passValues(sharedMessages.validateHexColor),
    )
    .required(sharedMessages.validateRequired),
})

export default labelFormValidation
